import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-pdf-viewer',
    templateUrl: './pdf-viewer.component.html',
    standalone: false
})
export class PdfViewerComponent implements OnInit {
  @Input() pdfUrl = null;
  page = 1;
  totalPages: number;
  isLoaded = false;
  @Output() loadedData = new EventEmitter<boolean>();

  ngOnInit(): void {

  }

  afterLoadComplete(pdf: any): void {
    this.totalPages = pdf.numPages;
    this.isLoaded = true;
    this.loadedData.emit(true);
  }

  nextPage() {
    if (this.page < this.totalPages) {
      this.page++;
    }
  }

  prevPage() {
    if (this.page > 1) {
      this.page--;
    }
  }
}
